import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "scroll-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.activeIndex == 0 ? 'active' : '')
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.activeIndex == 1 ? 'active' : '')
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.activeIndex == 2 ? 'active' : '')
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.activeIndex == 3 ? 'active' : '')
    }, null, 2)
  ]))
}